import * as constants from "../../constants";

const deviceNames = {
	// ios
	iphone8: "iPhone 8",
	iphone8plus: "iPhone 8 Plus",
	iphone11pro: "iPhone 11 Pro",
	iphone12: "iPhone 12",
	iphone13pro: "iPhone 13 Pro",
	iphone13promax: "iPhone 13 Pro Max",
	iphone14pro: "iPhone 14 Pro",
	iphone14promax: "iPhone 14 Pro Max",
	iphone15pro: "iPhone 15 Pro",
	iphone15promax: "iPhone 15 Pro Max",
	ipadair4thgeneration: "iPad Air 4th Gen",
	ipadpro129inch5thgeneration: "iPad Pro 5th Gen",
	ipad9thgeneration: "iPad 9th Gen",
	// android
	nexus5: "Nexus 5",
	pixel4: "Pixel 4",
	pixel4xl: "Pixel 4 XL",
	pixel6: "Pixel 6",
	pixel6pro: "Pixel 6 Pro",
	pixel7: "Pixel 7",
	pixel7pro: "Pixel 7 Pro",
	galaxytabs7: "Galaxy Tab S7",
};

export const getDevices = () => {
	return fetch("https://appetize.io/available-devices")
		.then(res => res.json())
		.then(({ ios, android }) => {
			return [
				...Object.keys(ios)
					.map(device => ({
						label: deviceNames[device] ?? device,
						supportedOS: ios[device].reverse(),
						height: 696,
						scale: 60,
						os: "ios",
						type: device.includes("ipad") ? "ipad" : "iphone",
						device,
						appetizeKey: constants.APPETIZE_PUBLIC_KEY,
					}))
					.reverse(),
				...Object.keys(android)
					.map(device => ({
						label: deviceNames[device] ?? device,
						supportedOS: android[device].reverse(),
						height: 696,
						scale: 60,
						os: "android",
						type: "android",
						device,
						appetizeKey: constants.APPETIZE_PUBLIC_KEY,
					}))
					.reverse(),
			];
		});
};
